module.exports = __webpack_public_path__ + "47ca229beb7dff4cefd3d4dad6325845.svg";